<template>
  <div class="layout-with-centered-max-width-child">
    <div>
          <div class="overall-container">
            <div v-if="loadingStarted">
              <loading></loading>
            </div>
            <div v-else-if="loadingSuccessful">
              <header>
                <div>
                  <div class="left-header">
                    <div>
                      <p class="name font-secondary">{{name}}</p>
                    </div>
                    <div class="section-2">
                      <div>
                        <div class="study-surveys-started">
                          <span>Surveys started: </span>
                          <span class="count">{{numberStarted}}</span>
                        </div>
                      </div>
                      <div>
                        <div class="study-surveys-completed">
                          <span>Surveys completed: </span>
                          <span class="count">{{numberCompleted}}</span>
                        </div>
                      </div>
                      <div v-if="isPurchaseFlashResultsPage">
                        <div class="view-info">
                          <router-link :to="publicStudyInfo">View Study Info</router-link>
                        </div>
                      </div>
                      <div v-if="isPublicFlashResultsPage" class="study-info-buttons">
                        <router-link v-if="userHasBoughtStudy" class="study-buy-button" :to="myPurchasesRoute">
                          <a class="font-secondary">View Purchases</a>
                        </router-link>
                        <div v-else class="study-buy-button" v-on:click="openHandler">
                          <span class="font-secondary">Buy Flash Results</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="isPurchaseFlashResultsPage" class="right-header">
                    <div class="pdng-1 vertical">
                      <div class="exports">
                        <a :href="excelUrl" target="_blank" class="xcl-export">
                          <Fai :icon="['fal', 'file-excel']" size="2x"/>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </header>
              <ResultsOverall></ResultsOverall>
              <div v-if="modalShowState">
                <Modal>
                  <div class="confirm-delete-study-dialog pdng-1">
                    <div>
                      <div class="exit-row">
                        <Fai :icon="['fal', 'times']" @click="closeModal()"/>
                      </div>
                      <div class="pdng-1">
                        <div class="prompt-row">
                          <span v-if="modalLoadedSuccessfully">Thank you for your purchase. The study data will be sent to your email and available in the dashboard</span>
                          <span v-else-if="modalFailedToLoad">Something went wrong.  Your credit card has not been charged</span>
                          <span v-else-if="modalStillLoading">Please wait while we process your card</span>
                        </div>
                        <div class="actions-row pdng-1 top">
                          <div class="action">
                        <span v-if="modalStillLoading">
                            <Loading></Loading>
                        </span>
                            <button v-else type="button" class="pure-button bigmi-wide-button bigmi-cyan-blue-2-button"
                                    @click="closeModal()">
                              <span v-if="modalLoadedSuccessfully">CONTINUE</span>
                              <span v-else-if="modalFailedToLoad">BACK</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>
              </div>
            </div>
            <div v-else-if="loadingFailed">
              <div class="centered-row">
                <ErrorPage>
                  <div slot="header">ERROR</div>
                  <div slot="message">Sorry, there was an error loading the page</div>
                </ErrorPage>
              </div>
            </div>
          </div>
    </div>
  </div>
</template>

<script>

  import {
    GET_BACKEND_URL, GET_CURRENT_STUDY_EXCEL_URL_FLASH, GET_HTTP_CONFIG, GET_IS_LOGGED_IN,
    GET_STRIPE_STANDARD_KEY,
    INSTANTIATE_CHECKOUT, LOAD_PURCHASES_OF_USER,
    LOAD_STUDY_RESULTS,
    LOAD_STUDY_RESULTS_2_MARKET_SEGMENT,
    LOADING_COMPLETED_FAILURE,
    LOADING_COMPLETED_SUCCESS, LOADING_PRISTINE,
    LOADING_STARTED, R_NAME_PUBLIC_STUDY_INFO, R_NAME_PURCHASES, SET_LOGIN_DROPDOWN_STATE, SET_LOGIN_REDIRECT
  } from "../../services/constants"
    import ResultsSecondary from "./ResultsSecondary"
    import ErrorPage from "./ErrorPage"
    import ResultsOverall from "./ResultsOverall"
  import http from "../../services/axios"
  import {mapGetters} from "vuex"

    export default {
        name: "PublicResults",
      components: {ResultsOverall, ErrorPage},
      created() {
        this.$store.dispatch(LOAD_STUDY_RESULTS)
          .then(response => {
            this.study = this.$store.state.studyResultsModule.studyResultsState.data
            let handler = this.createHandler()
            return this.$store.dispatch(INSTANTIATE_CHECKOUT, handler)
        })
          .then(() => {
            this.loadingStatus = this.$store.state.studyResultsModule.studyResults2MarketSegmentsState.error === null ? LOADING_COMPLETED_SUCCESS : LOADING_COMPLETED_FAILURE
          })
      },

      data(){
        return{
          loadingStatus: LOADING_STARTED,
          study: {},
          modalShowState: false,
          modalStatus: LOADING_PRISTINE
        }
      },

      methods: {
        openHandler(){
          if(this.isLoggedIn){
            this.checkoutInstance.open({
              name: `Study: ${this.name}`,
              description: `Completed ${this.numberCompleted} times`,
              zipCode: true,
              amount: 250
            })
          }
          else{
            this.openLoginDropdown()
          }
        },
        createHandler(){
          return {
            key: this.$store.getters[GET_STRIPE_STANDARD_KEY],
            image: 'https://stripe.com/img/documentation/checkout/marketplace.png',
            locale: 'auto',
            token: (token) => {
              this.modalLoading()

              let postBody = {
                stripeToken : token.id,
                email : token.email
              }

              return http.post(this.$store.getters[GET_BACKEND_URL](`studies/${this.study.studyID}/purchase/flash`), postBody, this.$store.getters[GET_HTTP_CONFIG])
                .then(response => {
                  this.$store.dispatch(LOAD_PURCHASES_OF_USER)
                  response.data.success ? this.modalSucceeded() : this.modalFailure()
                })
                .catch(err => {
                  this.modalFailure()
                })
            }
          }
        },
        closeModal(){
          this.modalShowState = false
        },
        modalSucceeded(){
          this.modalStatus = LOADING_COMPLETED_SUCCESS
          this.modalShowState = true
        },
        modalFailure(){
          this.modalStatus = LOADING_COMPLETED_FAILURE
          this.modalShowState = true
        },
        modalLoading(){
          this.modalStatus = LOADING_STARTED
          this.modalShowState = true
        },
        openLoginDropdown(){
          this.$store.commit(SET_LOGIN_REDIRECT, Object.assign({}, this.$route))
          this.$store.commit(SET_LOGIN_DROPDOWN_STATE, true)
        }
      },

      computed: {
        ...mapGetters([
          GET_CURRENT_STUDY_EXCEL_URL_FLASH,
        ]),
        loadingStarted() {
          return this.loadingStatus === LOADING_STARTED
        },
        loadingSuccessful() {
          return this.loadingStatus === LOADING_COMPLETED_SUCCESS
        },
        loadingFailed() {
          return this.loadingStatus === LOADING_COMPLETED_FAILURE
        },
        checkoutInstance() {
          return this.$store.state.paymentModule.checkoutObj
        },
        modalLoadedSuccessfully() {
          return this.modalStatus === LOADING_COMPLETED_SUCCESS
        },
        modalFailedToLoad() {
          return this.modalStatus === LOADING_COMPLETED_FAILURE
        },
        modalStillLoading() {
          return this.modalStatus === LOADING_STARTED
        },
        name(){
          return this.study.studyName
        },
        numberStarted(){
          return this.study.started
        },
        numberCompleted(){
          return this.study.completed
        },
        isLoggedIn() {
          return this.$store.getters[GET_IS_LOGGED_IN]
        },
        isPublicFlashResultsPage(){
          return this.$route.name === 'flashResults'
        },
        isPurchaseFlashResultsPage(){
          return this.$route.name === 'purchaseFlash'
        },
        publicStudyInfo(){
          return {
            name: R_NAME_PUBLIC_STUDY_INFO,
            params: {
              id: this.$route.params.id
            }
          }
        },
        excelUrl() {
          return this[GET_CURRENT_STUDY_EXCEL_URL_FLASH]
        },
        userHasBoughtStudy(){
          return this.$store.state.dataModule.purchases.data.some(purchase => {
            console.log(purchase)
            return purchase.study.id === parseInt(this.$route.params.id) && purchase.type === 'flash'
          })
        },
        myPurchasesRoute(){
          return { name: R_NAME_PURCHASES }
        },
      }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../../scss/main";


  .overall-container{
    padding: 3% 5%;
  }

  .loading {
    color: $red-2;
  }

  header {
    padding: 0 1%;
    > div {
      display: flex;

      > div {
        width: 50%;
      }
    }

    .left-header {

      p.name {
        color: $red-2;
        font-weight: bold;
      }

      .study-label, .study-status {
        color: $cyan-1;
        font-size: 15px;
        line-height: 22px;
      }

      .section-1 {
        padding: 0 0 1em 0;
      }

      .section-2 {
        color: $cyan-1;
        font-size: 15px;
        line-height: 25px;
        .count {
          color: $red-2;
        }
      }
    }

    .right-header {
      > div {
        display: flex;
        justify-content: flex-end;
      }
    }

    .exports {
      .xcl-export {
        padding: 1.5em .5em .5em;
        margin: 0 .5em 0 0;
      }

      .ppt-export {
        padding: 1.5em 0 .5em .5em;
      }
    }

    .study-info-buttons {
      margin-top: 20px;
      margin-bottom: 20px;
    }

    .study-buy-button {
      display: inline-block;
      text-decoration: none;
      padding: 8px 18px;
      border: 2px solid $red-2;
      border-radius: 3px;
      color: $white-1;
      font-size: 13px;
      font-weight: bold;
      line-height: 15px;
      text-align: center;
      background: $red-2;
      margin-right: 5px;
      cursor: pointer;
    }

  }

  .confirm-delete-study-dialog {
    background-color: $white-1;
    border-radius: 5px;

    .exit-row {
      display: flex;
      justify-content: flex-end;
    }

    .actions-row {
      display: flex;
      justify-content: center;
      .action {

      }
    }
  }

  .view-info {
    padding-bottom: 1em;
    display: flex;
    cursor: pointer;
  }
</style>
